import { MnoConfig } from '../types';

export const preprodConfig: MnoConfig = {
  id: 'berd_1',
  name: 'Life Preprod',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow
  },
  countryCode: '234',
  phoneNumberMask: '000 000 0000',
  appUrl: 'https://berd1.life.fun',
  locations: [
    "Madrid",
    "Rome",
    "Vienna",
    "Prague",
    "Budapest",
    "Warsaw",
    "Athens",
    "Lisbon",
    "Heidelberg",
    "Ankara"
  ],
};

